<template>
  <div class="w-100">
    <Jumbotron
      :item="processedItem"
      type="categories"
      :name="$t('main.groupers.categories.title')"
    />
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="w-100">
            <div v-if="isLoading" class="position-absolute w-100">
              <Loading />
            </div>
            <GridCSS v-else :items="categoryContent" :send-vector-click="true">
              <template #default="slotProps">
                <NormalVectorOverlay :data="slotProps.data" />
              </template>
            </GridCSS>
          </div>

          <Paginator class="my-4" v-bind="properties" @change-page="changePage" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import GridCSS from '@/components/Common/GridCSS';
import Jumbotron from '@/components/Common/Jumbotron';
import Loading from 'UI/Loading';
import NormalVectorOverlay from '@/components/Vectors/NormalVectorOverlay';
import Paginator from '@/components/Common/Paginator';

export default {
  components: {
    GridCSS,
    Jumbotron,
    Loading,
    NormalVectorOverlay,
    Paginator
  },
  computed: {
    ...mapState('categories', [
      'category',
      'categoryContent',
      'categoryTotalPages',
      'categoryCurrentPage',
      'isLoading'
    ]),
    ...mapGetters('categories', ['getDescription', 'getTitle']),
    nextPageLink() {
      return this.$urlBuilder('category', {
        id: this.$route.params.id,
        slug: this.$route.params.slug,
        page: this.categoryCurrentPage + 1
      });
    },
    prevPageLink() {
      return this.$urlBuilder('category', {
        id: this.$route.params.id,
        slug: this.$route.params.slug,
        page: this.categoryCurrentPage < 1 ? false : this.categoryCurrentPage - 1
      });
    },
    properties() {
      return {
        currentPage: this.categoryCurrentPage,
        totalPages: this.categoryTotalPages,
        nextPageLink: this.nextPageLink,
        prevPageLink: this.prevPageLink
      };
    },
    processedItem() {
      return {
        ...this.category,
        title: this.getTitle,
        description: this.getDescription
      };
    }
  },
  methods: {
    changePage(page, e) {
      e.preventDefault();
      const path = this.$urlBuilder('category', {
        id: this.$route.params.id,
        slug: this.$route.params.slug,
        page: page
      });
      this.$router.push({ path });
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 27px;
}
p {
  font-size: 16px;
}
.badge-secondary {
  background: #b8aea4;
}
</style>
